import { IconButton, useColorMode } from '@chakra-ui/react';
import React from 'react';
import { HiMoon, HiSun } from 'react-icons/hi';
import { useUserPreference } from 'hooks/datahook/settings';
import { useAuthStore } from 'stores/authStore';

const ColorModeBtn = (props) => {
    const [setAuthColorMode] = useAuthStore(state=>[state.setColorMode])
    const { colorMode, setColorMode, toggleColorMode } = useColorMode();
    const { updateProfile } = useUserPreference();
    const handleToggleColorMode = async () => {
        const newColorMode = colorMode === 'light' ? 'dark' : 'light';
        setColorMode(newColorMode);
        setAuthColorMode(newColorMode)
        await updateProfile({ theme: newColorMode.charAt(0).toUpperCase() + newColorMode.slice(1).toLowerCase()});
    }
    return (
        <IconButton
            icon={colorMode === 'light' ? <HiMoon /> : <HiSun />}
            onClick={() => { handleToggleColorMode() }}
            variant={'ghost'}
            size={'sm'}
            // border={'1px'}
            // borderColor={'gray.100'}
            aria-label="Options"
            boxShadow={'none'}
            px={1}
        />
    );
};

export default ColorModeBtn;
